import { DEFAULT_MAP_LAT, DEFAULT_MAP_LNG } from "../../../utils/map-defaults";

const KEY_LAT = "map:last-position:lat";
const KEY_LNG = "map:last-position:lng";
const KEY_ZOOM = "map:last-zoom";
const KEY_MY_LAT = "my_location_lat";
const KEY_MY_LNG = "my_location_lng";

/** 지도 탭·위치 설정(`/location`) 화면과 동일한 기본 줌 */
export const MAP_TAB_DEFAULT_ZOOM = 15;

/** 지도 탭 「내 위치」 버튼으로 이동할 때 줌 (조금 더 넓게) */
export const MAP_MY_LOCATION_BUTTON_ZOOM = 13;

export interface MapPosition {
  lat: number;
  lng: number;
  zoom: number;
}

export function getMapPosition(): MapPosition {
  return {
    lat: Number(sessionStorage.getItem(KEY_LAT)) || DEFAULT_MAP_LAT,
    lng: Number(sessionStorage.getItem(KEY_LNG)) || DEFAULT_MAP_LNG,
    zoom: Number(sessionStorage.getItem(KEY_ZOOM)) || MAP_TAB_DEFAULT_ZOOM,
  };
}

export function setMapPosition(pos: Partial<MapPosition>): void {
  if (pos.lat != null) sessionStorage.setItem(KEY_LAT, String(pos.lat));
  if (pos.lng != null) sessionStorage.setItem(KEY_LNG, String(pos.lng));
  if (pos.zoom != null) sessionStorage.setItem(KEY_ZOOM, String(pos.zoom));
}

export function getMyLocation(): { lat: number; lng: number } | null {
  const lat = sessionStorage.getItem(KEY_MY_LAT);
  const lng = sessionStorage.getItem(KEY_MY_LNG);
  if (lat == null || lng == null) return null;
  return { lat: Number(lat), lng: Number(lng) };
}

export function setMyLocation(lat: number, lng: number): void {
  sessionStorage.setItem(KEY_MY_LAT, String(lat));
  sessionStorage.setItem(KEY_MY_LNG, String(lng));
}
